import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import css from './PaginatorBlock.module.scss';

class PaginatorBlock extends React.Component {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        pages: PropTypes.number,
        currentPage: PropTypes.number,
        onPageChange: PropTypes.func.isRequired,
        prevButtonLabel: PropTypes.string,
        nextButtonLabel: PropTypes.string,
    };

    _handleClick = e => {
        const { page } = e.currentTarget.dataset;
        this.props.onPageChange(parseInt(page));
    }

    render () {
        const {
            pages,
            currentPage,
            prevButtonLabel,
            nextButtonLabel,
        } = this.props;

        const maxVisiblePagesAmount = 5;
        const pagesAmount = pages;
        const currentPageIndex = currentPage;

        const allPagesAreVisibe = maxVisiblePagesAmount >= pagesAmount;
        const visibilityRange = Math.floor(maxVisiblePagesAmount / 2);
        const leftBoundary = currentPageIndex <= visibilityRange + 1;
        const rightBoundary = currentPageIndex >=  pagesAmount - visibilityRange;

        const paginationArray = [];

        for (let pageIndex = 1; pageIndex < pagesAmount + 1; pageIndex++){
            let visible = false;

            if(allPagesAreVisibe){
                visible = true;
            }
            else if(leftBoundary){
                
                visible = pageIndex <= maxVisiblePagesAmount;
            }
            else if(rightBoundary){
                visible = pageIndex > pagesAmount - maxVisiblePagesAmount;
            }
            else {
                visible = Math.abs(currentPageIndex - pageIndex) <= visibilityRange;
            }

            let li;

            if (visible) {

                li = <li key={pageIndex}  className="pagination__item">
                    <button
                        className={cn("pagination__button", {
                            "pagination__button_active": pageIndex === currentPageIndex,
                        })}
                        data-page={pageIndex}
                        onClick={pageIndex === currentPageIndex ? null : this._handleClick}
                    >{pageIndex}</button>
                </li>;
            }

            paginationArray.push(li);
        }

        return (
            <div className={css.block}>
                <ul className="pagination">
                    {!allPagesAreVisibe && !leftBoundary &&
                    <li className="pagination__item pagination__item_prev">
                        <button
                            className="pagination__button pagination__button_prev"
                            data-page={currentPage - 1}
                            onClick={this._handleClick}
                            aria-label={prevButtonLabel ? prevButtonLabel : "Previous"}
                        >
                        </button>
                        <div className="pagination__button-dots">...</div>
                    </li>}
                    {paginationArray}
                    {!allPagesAreVisibe && !rightBoundary &&
                    <li className="pagination__item pagination__item_prev">
                        <div className="pagination__button-dots">...</div>
                        <button
                            className="pagination__button pagination__button_next"
                            data-page={currentPage + 1}
                            onClick={this._handleClick}
                            aria-label={nextButtonLabel ? nextButtonLabel: "Next"}
                        >
                        </button>
                    </li>}
                </ul>
            </div>
        );
    }
}

export default PaginatorBlock;



// WEBPACK FOOTER //
// ./src/components/PaginatorBlock/PaginatorBlock.jsx